import PropTypes from 'prop-types';

import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';
import Icon, { IconShape, IconScale, IconColor, IconView } from 'bloko/blocks/icon';

const ActError = ({ text }) => (
    <HoverTip placement={TipPlacement.Top} render={() => text} host={document.body} DropElement={Tip}>
        <Icon
            view={IconView.Exclamation}
            initial={IconColor.SpecialRedBranded}
            shape={IconShape.Triangle}
            scale={IconScale.Small}
        />
    </HoverTip>
);

ActError.propTypes = {
    text: PropTypes.string,
};

export default ActError;
